import React from "react";
import { Input } from "@elaniintc/goes-design-system";

interface StringOperationInputProps {
  /** Tipo de operación string */
  operation: string;
  /** Elementos para gestionar los valores */
  elements: Array<{ id?: string; value?: string }>;
  /** Callback para actualizar elementos */
  onElementsChange: (elements: Array<{ id?: string; value?: string }>) => void;
  /** Grupo de elementos */
  group?:
    | "down-left"
    | "down"
    | "down-right"
    | "left"
    | "right"
    | "up"
    | "up-left"
    | "up-right"
    | "single"
    | "middle"
    | "middle-right"
    | "middle-left";
}

/**
 * Componente para renderizar inputs específicos de operaciones string
 */
export const StringOperationInput: React.FC<StringOperationInputProps> = ({
  operation,
  elements,
  onElementsChange,
}) => {
  const updateElement = (index: number, value: string) => {
    const newElements = [...elements];
    while (newElements.length <= index) {
      newElements.push({
        id: Math.random().toString(36).substr(2, 9),
        value: "",
      });
    }
    newElements[index] = { ...newElements[index], value };
    onElementsChange(newElements);
  };

  // Replace operations
  if (operation === "replace" || operation === "replaceAll") {
    return (
      <>
        <Input
          className="w-1/2"
          group={"down-left"}
          placeholder="Texto a reemplazar"
          maxLength={255}
          value={elements[0]?.value || ""}
          onChange={(e) => updateElement(0, e.target.value)}
        />
        <Input
          className="w-1/2"
          group={"down-right"}
          placeholder="Texto de reemplazo"
          maxLength={255}
          value={elements[1]?.value || ""}
          onChange={(e) => updateElement(1, e.target.value)}
        />
      </>
    );
  }

  // Slice operation
  if (operation === "slice") {
    return (
      <>
        <Input
          className="w-1/2"
          group={"down-left"}
          placeholder="Desde índice"
          maxLength={255}
          value={elements[0]?.value || ""}
          onChange={(e) => {
            //allow just numbers
            if (!/^\d*$/.test(e.target.value)) return;
            updateElement(0, e.target.value);
          }}
        />
        <Input
          className="w-1/2"
          group={"down-right"}
          placeholder="Hasta índice"
          maxLength={255}
          value={elements[1]?.value || ""}
          onChange={(e) => {
            //allow just numbers
            if (!/^\d*$/.test(e.target.value)) return;
            updateElement(1, e.target.value);
          }}
        />
      </>
    );
  }

  // Single input operations
  if (operation === "repeat" || operation === "split") {
    return (
      <>
        <Input
          className="w-full"
          group={"down"}
          placeholder={
            operation === "repeat"
              ? "Escribir cuantas veces repetir"
              : "Escribe el separador"
          }
          maxLength={255}
          value={elements[0]?.value || ""}
          onChange={(e) => {
            if (operation === "repeat" && !/^\d*$/.test(e.target.value)) return;
            updateElement(0, e.target.value);
          }}
        />
      </>
    );
  }

  return null;
};
